<ng-container
  *ngIf="
    !(installationDetailsStore.loaded$ | async) && (installationDetailsStore.loading$ | async);
    else loadedEl
  "
>
  <app-panel data-at-owner-card>
    <app-panel-header>
      <div class="card-owner-header flex flex-row justify-between items-stretch">
        <span>{{ '+INSTALLATIONS.INSTALLATION.OWNER_CARD.OWNER' | translate }}</span>

        <div *ngIf="installationType" class="installation-type">
          {{
            '+INSTALLATIONS.INSTALLATIONS.DASHBOARD.' + installationType.toUpperCase() | translate
          }}
        </div>
      </div>
    </app-panel-header>
  </app-panel>
</ng-container>

<ng-template #loadedEl>
  <app-panel *ngrxLet="owner$ as owner" data-at-owner-card [expandable]="true" [expanded]="true">
    <app-panel-header>
      <ng-container *ngIf="ownershipType !== OwnershipType.CommercialV1; else buildingInfoHeader">
        <div class="card-owner-header flex flex-row justify-between items-stretch">
          <span>{{ '+INSTALLATIONS.INSTALLATION.OWNER_CARD.OWNER' | translate }}</span>
          <div *ngIf="installationType" class="installation-type">
            {{
              '+INSTALLATIONS.INSTALLATIONS.DASHBOARD.' + installationType.toUpperCase() | translate
            }}
          </div>
        </div>
      </ng-container>
      <ng-template #buildingInfoHeader>
        <div class="owner-title flex flex-row justify-between items-center">
          <span>
            {{ '+INSTALLATIONS.INSTALLATION.OWNER_CARD.BUILDING' | translate }}
          </span>
          <mat-icon class="edit-icon" (click)="editOwner($event)">edit</mat-icon>
        </div>
      </ng-template>
    </app-panel-header>

    <app-panel-content class="panel-content !flex flex-col gap-[8px]">
      <ng-container
        *ngIf="installationDetailsStore.installationBuildingInfo$ | async as buildingInfo"
      >
        <div class="flex flex-row gap-[8px]">
          <mat-icon>person</mat-icon>
          <ng-container *ngIf="ownershipType !== OwnershipType.CommercialV1; else vitocrossalOwner">
            <ng-container
              *ngIf="
                ownershipType !== OwnershipType.Oma && authStore.isRsaUser() | async;
                else nonClickablePerson
              "
            >
              <a
                data-at-owner-name-link
                class="person"
                gtm="onGoToPage"
                gtmAction="User details"
                gtmCategory="gatewayAccessList"
                [routerLink]="['/users', owner?.ownerId]"
                (click)="onRouteChange(owner)"
              >
                <div class="value" data-at-owner-name>{{ owner?.name | dash }}</div>
              </a>
            </ng-container>
            <ng-template #nonClickablePerson>
              <div class="value" data-at-owner-name>{{ owner?.name | dash }}</div>
            </ng-template>
          </ng-container>
          <ng-template #vitocrossalOwner>
            <div class="value" data-at-owner-name>
              {{ buildingInfo?.buildingName | dash }}
            </div>
          </ng-template>
        </div>

        <ng-container *ngIf="ownershipType !== OwnershipType.CommercialV1; else vitocrossalNACard">
          <div
            class="flex flex-row gap-[8px] justify-start items-start"
            *ngrxLet="address$ as address"
          >
            <mat-icon>location_on</mat-icon>

            <ng-container
              *ngIf="ownershipType === OwnershipType.ResidentialEndUser; else commercialAddress"
            >
              <a
                class="address"
                matTooltip="{{ '+INSTALLATIONS.MAP.VIEW_MAP_TOOLTIP' | translate }}"
                matTooltipPosition="above"
                gtm="onGoToPage"
                gtmAction="Map"
                gtmCategory="deviceCard"
                [routerLink]="['/installations/map']"
                [queryParams]="{
                  id: installationId
                }"
              >
                <div class="value" data-at-owner-street>{{ address?.street | dash }}</div>
                <div class="value" data-at-owner-city>{{ address?.city | dash }}</div>
              </a>
            </ng-container>
            <ng-template #commercialAddress>
              <div>
                <div class="value" data-at-owner-street>{{ address?.street | dash }}</div>
                <div class="value" data-at-owner-city>{{ address?.city | dash }}</div>
              </div>
            </ng-template>
          </div>
          <div class="flex flex-row gap-[8px]" *ngIf="ownershipType !== OwnershipType.Oma">
            <mat-icon>email</mat-icon>
            <div class="value" data-at-owner-email>{{ owner?.email | dash }}</div>
          </div>
          <div class="flex flex-row gap-[8px]">
            <mat-icon>call</mat-icon>
            <div class="value" data-at-owner-phone>{{ owner?.phone | formatPhoneNumber }}</div>
          </div>
        </ng-container>
        <ng-template #vitocrossalNACard>
          <div
            class="flex flex-row gap-[8px] justify-start items-start"
            *ngrxLet="address$ as address"
          >
            <mat-icon>location_on</mat-icon>

            <ng-container
              *ngIf="ownershipType === OwnershipType.ResidentialEndUser; else commercialAddress"
            >
              <a
                class="address"
                matTooltip="{{ '+INSTALLATIONS.MAP.VIEW_MAP_TOOLTIP' | translate }}"
                matTooltipPosition="above"
                gtm="onGoToPage"
                gtmAction="Map"
                gtmCategory="deviceCard"
                [routerLink]="['/installations/map']"
                [queryParams]="{
                  id: installationId
                }"
              >
                <div class="value" data-at-owner-street>{{ address?.street | dash }}</div>
                <div class="value" data-at-owner-city>{{ address?.city | dash }}</div>
              </a>
            </ng-container>
            <ng-template #commercialAddress>
              <div>
                <div class="value" data-at-owner-street>{{ address?.street | dash }}</div>
                <div class="value" data-at-owner-city>{{ address?.city | dash }}</div>
              </div>
            </ng-template>
          </div>
          <div class="flex flex-row gap-[8px]">
            <mat-icon>email</mat-icon>
            <div class="value" data-at-owner-email>{{ buildingInfo?.buildingEmail | dash }}</div>
          </div>
          <div class="flex flex-row gap-[8px]">
            <mat-icon>call</mat-icon>
            <div class="value" data-at-owner-phone>{{ buildingInfo?.buildingPhone | dash }}</div>
          </div>
        </ng-template>
      </ng-container>
    </app-panel-content>
    <app-panel-content class="!flex flex-col gap-[16px]">
      <div
        *ngIf="installationDetailsStore.isTransferInstallationButtonVisible$ | async"
        class="!flex justify-center items-center"
      >
        <button
          (click)="openTransferInstallationModal($event)"
          data-at-owner-card-transfer-installation-btn
          mat-stroked-button
          color="accent"
          appLargeButton
          gtm="onOpen"
          gtmAction="Transfer installation modal"
          gtmCategory="installationDetails"
        >
          {{ '+INSTALLATIONS.INSTALLATION.OWNER_CARD.TRANSFER_INSTALLATION' | translate }}
        </button>
      </div>

      <div *ngIf="ownershipType === OwnershipType.Oma">
        {{ '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.OMA.OMA_INSTALLATION' | translate }}
      </div>
      <ng-container
        *ngIf="
          !(installationDetailsStore.isAnyConsumerInAccessList$ | async) &&
          (installationDetailsStore.isInstallationWithCommercialOwner$ | async)
        "
        ><div class="value warn-value">
          {{
            '+INSTALLATIONS.INSTALLATION.DEVICE_CARD.LACK_OF_CONSUMER_DATA_INFORMATION' | translate
          }}
        </div></ng-container
      >
      <ng-container *ngIf="authStore.isCompanyFromGermany$ | async">
        <a
          *ngIf="installationDetailsStore.maintenancePackageLink$ | async as link"
          href="{{ link }}"
          target="_blank"
          mat-stroked-button
          appLargeButton
          color="accent"
          gtm="onOpen"
          gtmAction="Maintenance kit"
          gtmCategory="deviceCard"
          gtmLabel="{{ link }}"
          class="mat-stroked-button mat-primary maintenance-package-link flex flex-row justify-center items-center flex-[0_0_auto]"
        >
          {{ '+INSTALLATIONS.INSTALLATION.DEVICE_CARD.BUY_MAINTENANCE_KIT' | translate }}
        </a>
      </ng-container>

      <button
        class="unfollow-installation-btn mat-stroked-button mat-primary maintenance-package-link flex flex-row justify-center items-center flex-[0_0_auto]"
        *ngIf="installationDetailsStore.isCancelMonitoringButtonVisible$ | async"
        data-at-unfollow-device-btn
        mat-button
        color="accent"
        appLargeButton
        gtm="onOpen"
        gtmAction="Cancel monitoring service dialog"
        gtmCategory="deviceCard"
        [viConfirm]="{
          title:
            '+INSTALLATIONS.INSTALLATION.DEVICE_CARD.UNFOLLOW_INSTALLATION.DIALOG.TITLE'
            | translate,
          content:
            (owner?.name
              ? '+INSTALLATIONS.INSTALLATION.DEVICE_CARD.UNFOLLOW_INSTALLATION.DIALOG.MESSAGE'
              : '+INSTALLATIONS.INSTALLATION.DEVICE_CARD.UNFOLLOW_INSTALLATION.DIALOG.MESSAGE_WITHOUT_OWNER'
            )
            | translate
              : {
                  ownerName: owner?.name
                },
          cancelBtn: 'GENERAL.BUTTON.CANCEL' | translate,
          confirmBtn: 'GENERAL.BUTTON.UNFOLLOW' | translate
        }"
        (confirm)="onStopMonitoring(owner?.name)"
        (cancel)="onCancelStopMonitoring()"
      >
        {{ '+INSTALLATIONS.INSTALLATION.DEVICE_CARD.UNFOLLOW_INSTALLATION.BUTTON' | translate }}
      </button>
      <button
        *ngIf="showShareDeviceMonitoringButton"
        class="share-device-monitoring-btn mat-stroked-button mat-primary maintenance-package-link flex flex-row justify-center items-center flex-[0_0_auto]"
        data-at-share-device-monitoring-btn
        mat-button
        color="accent"
        appLargeButton
        gtm="onOpen"
        gtmAction="Share device monitoring dialog"
        gtmCategory="deviceCard"
        (click)="openShareDeviceMonitoringDialog()"
      >
        <span>{{
          '+INSTALLATIONS.INSTALLATION.DEVICE_CARD.SHARE_DEVICE_MONITORING.BUTTON' | translate
        }}</span>
        <mat-icon iconPositionEnd>arrow_forward</mat-icon>
      </button>
    </app-panel-content>
  </app-panel>
</ng-template>
